import axios from 'axios';
import AuthService from '../../Admin/services/AuthService';
import { normalizeClient, normalizeClients, unwrapList } from './superAdminApiUtils';

const API_URL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use((config) =>
  AuthService.prepareAuthenticatedRequest(config)
);

const ClientService = {
  getAllCLients: async () => {
    const response = await axios.get(`${API_URL}/Client/GetAllClients`);
    return normalizeClients(response.data);
  },

  getClientById: async (id) => {
    const response = await axios.get(`${API_URL}/Client/GetClientByid/${id}`);
    return normalizeClient(response.data) ?? response.data;
  },

  createClient: async (clientdata) => {
    const response = await axios.post(`${API_URL}/Client/CreateClient`, clientdata);
    return response.data;
  },

  updateClient: async (id, clientdata) => {
    const response = await axios.put(`${API_URL}/Client/UpdateClient/${id}`, clientdata);
    return response.data;
  },

  deleteClient: async (id) => {
    const response = await axios.delete(`${API_URL}/Client/DeleteClient/${id}`);
    return response.data;
  },

  getUsersByClientId: async (clientId) => {
    const response = await axios.get(`${API_URL}/User/GetUsersByClientId/${clientId}`);
    return unwrapList(response.data);
  },
};

export default ClientService;
